module.exports = __webpack_public_path__ + "static/media/logoIn.8c75ef78.svg";